import { j as o } from "./index.es9.js";
import { composeClassNames as e } from "./index.es88.js";
const r = ({
  children: a = null,
  header: i,
  state: s = "info",
  hasNoIcon: n = !1,
  ariaLive: l
}) => /* @__PURE__ */ o.jsx(
  "div",
  {
    className: e("bl-info-box", `bl-info-box--${s}`),
    ...l && { "aria-live": l },
    children: /* @__PURE__ */ o.jsxs("div", { className: "bl-info-box__wrapper", children: [
      i && /* @__PURE__ */ o.jsxs(
        "div",
        {
          className: e(
            "bl-info-box__header",
            n && "bl-info-box__header--no-icon"
          ),
          children: [
            !n && /* @__PURE__ */ o.jsx(
              "i",
              {
                "aria-hidden": "true",
                className: e(
                  "bl-info-box__icon",
                  `bl-icon--${s}`,
                  "bl-icon--medium"
                )
              }
            ),
            /* @__PURE__ */ o.jsx("div", { className: "bl-info-box__header-content", children: i })
          ]
        }
      ),
      a && /* @__PURE__ */ o.jsx(
        "div",
        {
          className: e(
            "bl-info-box__content",
            n && "bl-info-box__content--no-icon",
            !i && "bl-info-box__content--no-header"
          ),
          children: a
        }
      )
    ] })
  }
);
export {
  r as default
};
//# sourceMappingURL=index.es60.js.map
